import * as payrollTypes from "../../types/admin/payrollTypes";

export const updateEmpPayrollReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.UPDATE_EMPLOYEE_PAYROLL_SETTING_REQUEST:
      return {
        ...state,
        updateEmpPayrollLoading: true,
      };
    case payrollTypes.UPDATE_EMPLOYEE_PAYROLL_SETTING_SUCCESS:
      return {
        ...state,
        updateEmpPayrollLoading: false,
        updateEmpPayrollInfo: payload,
        updateEmpPayrollErrors: "",
      };
    case payrollTypes.UPDATE_EMPLOYEE_PAYROLL_SETTING_FAIL:
      return {
        ...state,
        updateEmpPayrollLoading: false,
        updateEmpPayrollErrors: payload,
        updateEmpPayrollInfo: [],
      };
    default:
      return state;
  }
};

export const getEmpPayrollReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.GET_EMPLOYEE_PAYROLL_SETTING_REQUEST:
      return {
        ...state,
        getEmpPayrollLoading: true,
      };
    case payrollTypes.GET_EMPLOYEE_PAYROLL_SETTING_SUCCESS:
      return {
        ...state,
        getEmpPayrollLoading: false,
        getEmpPayrollInfo: payload,
        getEmpPayrollErrors: "",
      };
    case payrollTypes.GET_EMPLOYEE_PAYROLL_SETTING_FAIL:
      return {
        ...state,
        getEmpPayrollLoading: false,
        getEmpPayrollErrors: payload,
        getEmpPayrollInfo: [],
      };
    default:
      return state;
  }
};

export const getOffBoardingUserDataReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.GET_OFF_BOARDING_USER_DATA_REQUEST:
      return {
        ...state,
        getOffBoardingUserDataLoading: true,
      };
    case payrollTypes.GET_OFF_BOARDING_USER_DATA_SUCCESS:
      return {
        ...state,
        getOffBoardingUserDataLoading: false,
        getOffBoardingUserDataInfo: payload,
        getOffBoardingUserDataErrors: "",
      };
    case payrollTypes.GET_OFF_BOARDING_USER_DATA_FAIL:
      return {
        ...state,
        getOffBoardingUserDataLoading: false,
        getOffBoardingUserDataErrors: payload,
        getOffBoardingUserDataInfo: [],
      };
    default:
      return state;
  }
};

export const addOffBoardingDataReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.ADD_OFF_BOARDING_DATA_REQUEST:
      return {
        ...state,
        addOffBoardingDataLoading: true,
      };
    case payrollTypes.ADD_OFF_BOARDING_DATA_SUCCESS:
      return {
        ...state,
        addOffBoardingDataLoading: false,
        addOffBoardingDataInfo: payload,
        addOffBoardingDataErrors: "",
      };
    case payrollTypes.ADD_OFF_BOARDING_DATA_FAIL:
      return {
        ...state,
        addOffBoardingDataLoading: false,
        addOffBoardingDataErrors: payload,
        addOffBoardingDataInfo: [],
      };
    default:
      return state;
  }
};

export const addAppraisalDataReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.ADD_APPRAISAL_DATA_REQUEST:
      return {
        ...state,
        addAppraisalDataLoading: true,
      };
    case payrollTypes.ADD_APPRAISAL_DATA_SUCCESS:
      return {
        ...state,
        addAppraisalDataLoading: false,
        addAppraisalDataInfo: payload,
        addAppraisalDataErrors: "",
      };
    case payrollTypes.ADD_APPRAISAL_DATA_FAIL:
      return {
        ...state,
        addAppraisalDataLoading: false,
        addAppraisalDataErrors: payload,
        addAppraisalDataInfo: [],
      };
    default:
      return state;
  }
};

export const addTransferDataReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.ADD_TRANSFER_DATA_REQUEST:
      return {
        ...state,
        addTransferDataLoading: true,
      };
    case payrollTypes.ADD_TRANSFER_DATA_SUCCESS:
      return {
        ...state,
        addTransferDataLoading: false,
        addTransferDataInfo: payload,
        addTransferDataErrors: "",
      };
    case payrollTypes.ADD_TRANSFER_DATA_FAIL:
      return {
        ...state,
        addTransferDataLoading: false,
        addTransferDataErrors: payload,
        addTransferDataInfo: [],
      };
    default:
      return state;
  }
};

export const addMoveDataReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.ADD_MOVE_DATA_REQUEST:
      return {
        ...state,
        addMoveDataLoading: true,
      };
    case payrollTypes.ADD_MOVE_DATA_SUCCESS:
      return {
        ...state,
        addMoveDataLoading: false,
        addMoveDataInfo: payload,
        addMoveDataErrors: "",
      };
    case payrollTypes.ADD_MOVE_DATA_FAIL:
      return {
        ...state,
        addMoveDataLoading: false,
        addMoveDataErrors: payload,
        addMoveDataInfo: [],
      };
    default:
      return state;
  }
};

export const getOffBoardingAllDataReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.GET_OFF_BOARDING_ALL_DATA_REQUEST:
      return {
        ...state,
        getOffBoardingAllDataLoading: true,
      };
    case payrollTypes.GET_OFF_BOARDING_ALL_DATA_SUCCESS:
      return {
        ...state,
        getOffBoardingAllDataLoading: false,
        getOffBoardingAllDataInfo: payload,
        getOffBoardingAllDataErrors: "",
      };
    case payrollTypes.GET_OFF_BOARDING_ALL_DATA_FAIL:
      return {
        ...state,
        getOffBoardingAllDataLoading: false,
        getOffBoardingAllDataErrors: payload,
        getOffBoardingAllDataInfo: [],
      };
    default:
      return state;
  }
};

export const getAnotherCompanySalaryBreakDownReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN_REQUEST:
      return {
        ...state,
        getAnotherCompanySalaryBreakDownLoading: true,
      };
    case payrollTypes.GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN_SUCCESS:
      return {
        ...state,
        getAnotherCompanySalaryBreakDownLoading: false,
        getAnotherCompanySalaryBreakDownInfo: payload,
        getAnotherCompanySalaryBreakDownErrors: "",
      };
    case payrollTypes.GET_ANOTHER_COMPANY_SALARY_BREAK_DOWN_FAIL:
      return {
        ...state,
        getAnotherCompanySalaryBreakDownLoading: false,
        getAnotherCompanySalaryBreakDownErrors: payload,
        getAnotherCompanySalaryBreakDownInfo: [],
      };
    default:
      return state;
  }
};

export const updateEmpPayrollCategoryReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.UPDATE_PAYROLL_CATEGORY_SETTING_REQUEST:
      return {
        ...state,
        updateEmpPayrollLoading: true,
      };
    case payrollTypes.UPDATE_PAYROLL_CATEGORY_SETTING_SUCCESS:
      return {
        ...state,
        updateEmpPayrollLoading: false,
        updateEmpPayrollInfo: payload,
        updateEmpPayrollErrors: "",
      };
    case payrollTypes.UPDATE_PAYROLL_CATEGORY_SETTING_FAIL:
      return {
        ...state,
        updateEmpPayrollLoading: false,
        updateEmpPayrollErrors: payload,
        updateEmpPayrollInfo: [],
      };
    default:
      return state;
  }
};

export const getEmpPayrollTimeRecordReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.GET_EMPLOYEE_PAYROLL_TIMERECORD_REQUEST:
      return {
        ...state,
        getEmpPayrollTimerecordLoading: true,
      };
    case payrollTypes.GET_EMPLOYEE_PAYROLL_TIMERECORD_SUCCESS:
      return {
        ...state,
        getEmpPayrollTimerecordLoading: false,
        getEmpPayrollTimerecordInfo: payload,
        getEmpPayrollTimerecordErrors: "",
      };
    case payrollTypes.GET_EMPLOYEE_PAYROLL_TIMERECORD_FAIL:
      return {
        ...state,
        getEmpPayrollTimerecordLoading: false,
        getEmpPayrollTimerecordErrors: payload,
        getEmpPayrollTimerecordInfo: [],
      };
    default:
      return state;
  }
};

export const addMainPayrollOfCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.ADD_MAIN_PAYROLL_OF_COMPANY_REQUEST:
      return {
        ...state,
        addMainPayLoading: true,
      };
    case payrollTypes.ADD_MAIN_PAYROLL_OF_COMPANY_SUCCESS:
      return {
        ...state,
        addMainPayLoading: false,
        addMainPayInfo: payload,
        addMainPayErrors: "",
      };
    case payrollTypes.ADD_MAIN_PAYROLL_OF_COMPANY_FAIL:
      return {
        ...state,
        addMainPayLoading: false,
        addMainPayErrors: payload,
        addMainPayInfo: [],
      };
    default:
      return state;
  }
};

export const addGeneratePayrollOfCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.ADD_GENERATE_PAYROLL_OF_COMPANY_REQUEST:
      return {
        ...state,
        addGeneratePayLoading: true,
      };
    case payrollTypes.ADD_GENERATE_PAYROLL_OF_COMPANY_SUCCESS:
      return {
        ...state,
        addGeneratePayLoading: false,
        addGeneratePayInfo: payload,
        addGeneratePayErrors: "",
      };
    case payrollTypes.ADD_GENERATE_PAYROLL_OF_COMPANY_FAIL:
      return {
        ...state,
        addGeneratePayLoading: false,
        addGeneratePayErrors: payload,
        addGeneratePayInfo: [],
      };
    default:
      return state;
  }
};

export const deletePayrollOfCompanyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.DELETE_PAYROLL_REQUEST:
      return {
        ...state,
        deletePayrollLoading: true,
      };
    case payrollTypes.DELETE_PAYROLL_SUCCESS:
      return {
        ...state,
        deletePayrollLoading: false,
        deletePayrollInfo: payload,
        deletePayrollErrors: "",
      };
    case payrollTypes.DELETE_PAYROLL_FAIL:
      return {
        ...state,
        deletePayrollLoading: false,
        deletePayrollErrors: payload,
        deletePayrollInfo: [],
      };
    default:
      return state;
  }
};

export const firstCategoryReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.SET_FIRST_CATEGORY:
      return {
        ...state,
        firstCategory: payload,
      };
    default:
      return state;
  }
};

export const AddDataInPayrollReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.SET_DATA_CATEGORY:
      return {
        ...state,
        addPayrollData: payload,
      };
    default:
      return state;
  }
};

export const addPayrollAdditionsReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.SET_PAYROLL_ADDITION_DEDUCTION:
      return {
        ...state,
        addPayrollDatas: payload,
      };
    default:
      return state;
  }
};

export const addSalaryBreakDownReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.ADD_SALARY_BREAK_DOWN_REQUEST:
      return {
        ...state,
        addSalaryBreakDownLoading: true,
      };
    case payrollTypes.ADD_SALARY_BREAK_DOWN_SUCCESS:
      return {
        ...state,
        addSalaryBreakDownLoading: false,
        addSalaryBreakDownInfo: payload,
        addSalaryBreakDownErrors: "",
      };
    case payrollTypes.ADD_SALARY_BREAK_DOWN_FAIL:
      return {
        ...state,
        addSalaryBreakDownLoading: false,
        addSalaryBreakDownErrors: payload,
        addSalaryBreakDownInfo: [],
      };
    default:
      return state;
  }
};

export const addSalaryBreakDownByUserReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.ADD_SALARY_BREAK_DOWN_BY_USER_REQUEST:
      return {
        ...state,
        addEmpSalaryBreakDownLoading: true,
      };
    case payrollTypes.ADD_SALARY_BREAK_DOWN_BY_USER_SUCCESS:
      return {
        ...state,
        addEmpSalaryBreakDownLoading: false,
        addEmpSalaryBreakDownInfo: payload,
        addEmpSalaryBreakDownErrors: "",
      };
    case payrollTypes.ADD_SALARY_BREAK_DOWN_BY_USER_FAIL:
      return {
        ...state,
        addEmpSalaryBreakDownLoading: false,
        addEmpSalaryBreakDownErrors: payload,
        addEmpSalaryBreakDownInfo: [],
      };
    default:
      return state;
  }
};

export const uploadPayslipsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.UPLOAD_PAYSLIPS_REQUEST:
      return {
        ...state,
        uploadPayslipsLoading: true,
      };
    case payrollTypes.UPLOAD_PAYSLIPS_SUCCESS:
      return {
        ...state,
        uploadPayslipsLoading: false,
        uploadPayslipsInfo: payload,
        uploadPayslipsErrors: "",
      };
    case payrollTypes.UPLOAD_PAYSLIPS_FAIL:
      return {
        ...state,
        uploadPayslipsLoading: false,
        uploadPayslipsErrors: payload,
        uploadPayslipsInfo: [],
      };
    default:
      return state;
  }
};

export const editUploadPayslipsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.EDIT_UPLOAD_PAYSLIPS_REQUEST:
      return {
        ...state,
        editUploadPayslipsLoading: true,
      };
    case payrollTypes.EDIT_UPLOAD_PAYSLIPS_SUCCESS:
      return {
        ...state,
        editUploadPayslipsLoading: false,
        editUploadPayslipsInfo: payload,
        editUploadPayslipsErrors: "",
      };
    case payrollTypes.EDIT_UPLOAD_PAYSLIPS_FAIL:
      return {
        ...state,
        editUploadPayslipsLoading: false,
        editUploadPayslipsErrors: payload,
        editUploadPayslipsInfo: [],
      };
    default:
      return state;
  }
};

export const createGenerateInUploadPayslipsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.CREATE_GENERATE_IN_UPOLAD_PAYSLIPS_REQUEST:
      return {
        ...state,
        createGenearteInUploadPayslipsLoading: true,
      };
    case payrollTypes.CREATE_GENERATE_IN_UPOLAD_PAYSLIPS_SUCCESS:
      return {
        ...state,
        createGenearteInUploadPayslipsLoading: false,
        createGenearteInUploadPayslipsInfo: payload,
        createGenearteInUploadPayslipsErrors: "",
      };
    case payrollTypes.CREATE_GENERATE_IN_UPOLAD_PAYSLIPS_FAIL:
      return {
        ...state,
        createGenearteInUploadPayslipsLoading: false,
        createGenearteInUploadPayslipsErrors: payload,
        createGenearteInUploadPayslipsInfo: [],
      };
    default:
      return state;
  }
};

export const addImportPayrollProcessReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.SET_IMPORT_PROCESS_PAYROLL:
      return {
        ...state,
        addImportProcessPayroll: payload,
      };
    default:
      return state;
  }
};

export const addImportAdditionalReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.SET_IMPORT_ADDITIONAL_PAYROLL:
      return {
        ...state,
        addImportAdditionalPayroll: payload,
      };
    default:
      return state;
  }
};

export const addImportReviewReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.SET_IMPORT_REVIEW_PAYROLL:
      return {
        ...state,
        addImportReviewPayroll: payload,
      };
    default:
      return state;
  }
};

export const addPayrollProcessReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.SET_PAYROLL_PROCESS:
      return {
        ...state,
        addPayrollProcessPayroll: payload,
      };
    default:
      return state;
  }
};

export const AddOffBoardingReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case payrollTypes.ADD_OFFBOARDING_DATA_SUCCESS:
      return {
        ...state,
        addOffBoarding: payload,
      };
    default:
      return state;
  }
};
